// @ts-nocheck
class WIcaro extends HTMLElement {
  constructor() {
    super();
    this.slideWidth = null; // measured width of one slide (with margins)
    this._onResize = this.computeSlideWidth.bind(this);
  }

  connectedCallback() {
    this.computeSlideWidth();
    this.pBp();
    this.nBp();
    this.handleScroll();

    window.addEventListener('resize', this._onResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this._onResize);
  }

  getBox() {
    return this.querySelector('.WI_slider');
  }

  computeSlideWidth() {
    const slide = this.querySelector('.WI_sliderCard');
    const box = this.getBox();
    if (!slide || !box) return;

    const rect = slide.getBoundingClientRect();
    const cs = window.getComputedStyle(slide);
    const marginLeft = parseFloat(cs.marginLeft) || 0;
    const marginRight = parseFloat(cs.marginRight) || 0;

    this.slideWidth = Math.round(rect.width + marginLeft + marginRight);

    this.updateButtonsVisibility();
  }

  updateButtonsVisibility() {
    const box = this.getBox();
    const nB = this.querySelector('.WI_n');
    const pB = this.querySelector('.WI_p');
    if (!box || !nB || !pB) return;

    const maxScrollLeft = box.scrollWidth - box.clientWidth;
    const tolerance = 2;

    if (box.scrollLeft <= tolerance) {
      pB.style.opacity = "0.4";
      pB.style.pointerEvents = "none";
    } else {
      pB.style.opacity = "1";
      pB.style.pointerEvents = "auto";
    }

    if (box.scrollLeft >= maxScrollLeft - tolerance) {
      nB.style.opacity = "0,4";
      nB.style.pointerEvents = "none";
    } else {
      nB.style.opacity = "1";
      nB.style.pointerEvents = "auto";
    }
  }

 updateProgressBar() {
  const box = this.getBox();
  const progressBar = this.querySelector('.WI_caro_navi_progress_indicator');
  if (!box || !progressBar) return;

  const totalWidth = box.scrollWidth;

  if (totalWidth <= 0) {
    progressBar.style.width = '0%';
    return;
  }

  const visibleProgress = (box.scrollLeft + box.clientWidth) / totalWidth;

  const progress = Math.min(visibleProgress * 100, 100);

  progressBar.style.width = `${progress}%`;
}

  handleScroll() {
    const box = this.getBox();
    if (!box) return;

    box.addEventListener('scroll', () => {
    this.updateButtonsVisibility();
    this.updateProgressBar();
  });

    this.updateButtonsVisibility();
    this.updateProgressBar();
  }

  nBp() {
    const nB = this.querySelector('.WI_n');
    const box = this.getBox();
    if (!nB || !box) return;

    nB.addEventListener('click', () => {
      const delta = this.slideWidth || box.clientWidth;
      const maxScrollLeft = box.scrollWidth - box.clientWidth;
      let newScrollLeft = box.scrollLeft + delta;

      if (newScrollLeft > maxScrollLeft) newScrollLeft = maxScrollLeft;

      box.scrollTo({
        left: Math.round(newScrollLeft),
        behavior: 'smooth'
      });
    });
  }

  pBp() {
    const pB = this.querySelector('.WI_p');
    const box = this.getBox();
    if (!pB || !box) return;

    pB.addEventListener('click', () => {
      const delta = this.slideWidth || box.clientWidth;
      let newScrollLeft = box.scrollLeft - delta;
      if (newScrollLeft < 0) newScrollLeft = 0;

      box.scrollTo({
        left: Math.round(newScrollLeft),
        behavior: 'smooth'
      });
    });
  }
}

customElements.define('wi-caro', WIcaro);
